import moment from 'moment';

export default function GRReportInstanceController(
  $q,
  $scope,
  $rootScope,
  loaderService,
  orgDataService,
  reportsDataService,
  reportsSharedModelService,
  ssDialogService,
  confirmDialog,
  alerts,
  editReportInstanceCommentDialog,
  editReportStatusDialog,
  selectReportDestinationDialog,
) {
  const vm = this;

  vm.handleExpand = handleExpand;

  vm.handleArchiveReport = _handleArchiveReport;
  vm.handleAddNote = handleAddNote;
  vm.handleMarkReportAsReviewed = handleMarkReportAsReviewed;
  vm.handleUnpublishReport = handleUnpublishReport;

  _activate();

  /** ********************************************
   * Event Handlers
   */

  function handleExpand() {
    if (vm.canExpand) {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleArchiveReport($event) {
    const reportName = vm.reportInstance.reportName;
    const generatedDate = moment(vm.reportInstance.createDate).format('MM/DD/YYYY');
    const generatedTime = moment(vm.reportInstance.createDate).format('hh:mm:ss a');

    return _showArchiveConfirmDialog($event, {
      dialogTitle: 'Archive Report?',
      message: `Are you sure you want to archive the "${reportName}" Report Instance generated on ${generatedDate} at ${generatedTime}?`,
      handleYesClick: _confirmArchive,
      handleNoClick: _closeArchiveConfirmDialog,
    });
  }

  function _showArchiveConfirmDialog($event, locals) {
    ssDialogService.dialogs.reports.archiveGeneratedReportInstanceConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.archiveGeneratedReportInstanceConfirmDialog);
  }

  function _closeArchiveConfirmDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.archiveGeneratedReportInstanceConfirmDialog);
  }

  function _confirmArchive() {
    loaderService.showViewLoader = true;
    return reportsDataService.archiveReportInstance(vm.reportInstance.reportInstanceId).then((success) => {
      loaderService.showViewLoader = false;
      if (success) {
        $rootScope.$broadcast(`reports.generatedReports.reportType.reportInstanceArchived`, vm.reportInstance); 
        alerts.success('The Report Instance has been successfully archived.');
        return _closeArchiveConfirmDialog();
      } else {
        alerts.error('An error occurred while archiving the Report Instance.');
      }
    });
  }

  function handleAddNote($event) {
    ssDialogService.dialogs.reports.editReportInstanceCommentDialog = ssDialogService.alert(
      editReportInstanceCommentDialog.getOptions($event, {
        reportInstanceComment: {
          reportInstanceId: vm.reportInstance.reportInstanceId,
          reportInstanceCommentId: 0,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.editReportInstanceCommentDialog);
  }

  function handleMarkReportAsReviewed($event) {
    loaderService.showViewLoader = true;

    const promises = [
      orgDataService.getIsNavantaUser(),
      orgDataService.getSelectableUsers(),
    ];

    return $q.all(promises).then((response) => {
      loaderService.showViewLoader = false;
      ssDialogService.dialogs.reports.editReportStatusDialog = ssDialogService.alert(
        editReportStatusDialog.getOptions($event, {
          reportInstance: vm.reportInstance,
          isNavantaUser: response[0].data.result,
          users: response[1].data.result,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.reports.editReportStatusDialog);
    });
  }

  function handleUnpublishReport($event) {
    loaderService.showViewLoader = true;
    const destinations = [
      { destinationId: 1, destinationName: 'theSafe' },
      { destinationId: 2, destinationName: 'theSentry' }
    ];

    return orgDataService.getIsNavantaUser().then((response) => {
      if (response.data.result === true) {
        loaderService.showViewLoader = false;
        ssDialogService.dialogs.reports.selectReportDestinationDialog = ssDialogService.alert(
          selectReportDestinationDialog.getOptions($event, {
            reportInstance: vm.reportInstance,
            destinations,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.reports.selectReportDestinationDialog);
      } else {
        reportsSharedModelService.unpublishReportInstance(vm.reportInstance.reportId, vm.reportInstance.reportInstanceId, 1) // eslint-disable-line max-len
          .then((success) => {
            loaderService.showViewLoader = false;
            if (success) {
              $rootScope.$broadcast(`reports.generatedReports.reportType.reportInstanceUnpublished`, vm.reportInstance); // eslint-disable-line max-len
              alerts.success('The Report has been successfully unpublished and moved to My Reports.');
            } else {
              alerts.error('Error occurred while unpublishing the Report.');
            }
          });
      }
    });
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {
    vm.canExpand = false;
    vm.isExpanded = false;

    _setCanExpand();

    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshReportStatus', (event, opt) => {
      if (opt.reportInstanceId === vm.reportInstance.reportInstanceId) {
        _updateReportStatus();
      }
    });

    $scope.$on('refreshReportInstanceStatuses', (event, opt) => {
      if (opt.reportInstanceId === vm.reportInstance.reportInstanceId) {
        _loadStatuses();
      }
    });

    $scope.$on('refreshReportInstanceComments', (event, opt) => {
      if (opt.reportInstanceId === vm.reportInstance.reportInstanceId) {
        _loadComments();
      }
    });
  }

  function _updateReportStatus() {
    loaderService.showViewLoader = true;
    const promises = [
      reportsDataService.getReportInstance(vm.reportInstance.reportInstanceId),
      reportsDataService.getReportInstanceStatuses(vm.reportInstance.reportInstanceId),
      reportsDataService.getReportInstanceNotes(vm.reportInstance.reportInstanceId),
    ];

    return $q.all(promises).then((response) => {
      vm.reportInstance.acknowledgeStatusId = response[0].data.acknowledgeStatusId;
      vm.reportInstance.acknowledgeStatus = response[0].data.acknowledgeStatus;
      vm.reportInstance.reportInstanceStatuses = response[1].data;
      vm.reportInstance.reportInstanceComments = response[2].data;
      _setCanExpand();
      loaderService.showViewLoader = false;
    });
  }

  function _loadStatuses() {
    loaderService.showViewLoader = true;
    return reportsDataService.getReportInstanceStatuses(vm.reportInstance.reportInstanceId).then((response) => {
      vm.reportInstance.reportInstanceStatuses = response.data;
      _setCanExpand();
      loaderService.showViewLoader = false;
    });
  }

  function _loadComments() {
    loaderService.showViewLoader = true;
    return reportsDataService.getReportInstanceNotes(vm.reportInstance.reportInstanceId).then((response) => {
      vm.reportInstance.reportInstanceComments = response.data;
      _setCanExpand();
      loaderService.showViewLoader = false;
    });
  }

  function _setCanExpand() {
    const risce = (vm.reportInstance.reportInstanceStatuses !== null)
      && (vm.reportInstance.reportInstanceStatuses.length > 0);

    const ricce = (vm.reportInstance.reportInstanceComments !== null)
      && (vm.reportInstance.reportInstanceComments.length > 0);

    if (risce || ricce) {
      vm.canExpand = true;
    } else {
      vm.canExpand = false;
      vm.isExpanded = false;
    }
  }
}

GRReportInstanceController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'loaderService',
  'orgDataService',
  'reportsDataService',
  'reportsSharedModelService',
  'ssDialogService',
  'confirmDialog',
  'alerts',
  'editReportInstanceCommentDialog',
  'editReportStatusDialog',
  'selectReportDestinationDialog',
];
